import {BaseService} from './Core/BaseService';

class LibraryService extends BaseService {
    get Url() { return super.Url + "/library"; }

    SetAuthToken() {
        return this.SendRequest(BaseService.POST, {});
    }
}

export const service = new LibraryService();

